import React from 'react';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import EditingContainer from '../EditingContainer';
import LibraryContentsList from './LibraryContentsList';
import Group from './Group';

const AdvancedEdit = ({
  libraryContents,
  onCreateContent,
  onRemoveContent,
  removeTooltip,
  suggestionsProps,
  toggleEditing,
}) => (
  <EditingContainer onDone={toggleEditing}>
    <RemoteAutoComplete
      placeholder="Add a Group by Name"
      className="NewInput NewInput--light NewInput--fw mb-16 mt-8"
      onSuggestionSelected={onCreateContent}
      {...suggestionsProps}
    />
    <LibraryContentsList libraryContents={libraryContents}>
      {content => (
        <Group
          key={content.group.id}
          name={content.group.name}
          removeTooltip={removeTooltip}
          onRemove={() => onRemoveContent(content)}
          editable
        />
      )}
    </LibraryContentsList>
  </EditingContainer>
);

export default AdvancedEdit;
